import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CookiePreferences, CookieListenerDirective, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ContentBlock } from '../../models';
import { SafePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-content-block-wysiwyg',
  templateUrl: './content-block-wysiwyg.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CookieListenerDirective, SafePipe, StripEmbedPipe],
})
export class ContentBlockWysiwygComponent {
  @Input() block!: ContentBlock;
  @Input() cookies?: CookiePreferences;

  constructor() {}
}
